"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CoordinateList = _interopRequireDefault(require("../geom/CoordinateList"));

var _SegmentNode = _interopRequireDefault(require("./SegmentNode"));

var _Iterator = _interopRequireDefault(require("../../../../java/util/Iterator"));

var _Coordinate = _interopRequireDefault(require("../geom/Coordinate"));

var _NodedSegmentString = _interopRequireDefault(require("./NodedSegmentString"));

var _Integer = _interopRequireDefault(require("../../../../java/lang/Integer"));

var _ArrayList = _interopRequireDefault(require("../../../../java/util/ArrayList"));

var _RuntimeException = _interopRequireDefault(require("../../../../java/lang/RuntimeException"));

var _Assert = _interopRequireDefault(require("../util/Assert"));

var _TreeMap = _interopRequireDefault(require("../../../../java/util/TreeMap"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SegmentNodeList =
/*#__PURE__*/
function () {
  function SegmentNodeList() {
    _classCallCheck(this, SegmentNodeList);

    SegmentNodeList.constructor_.apply(this, arguments);
  }

  _createClass(SegmentNodeList, [{
    key: "getSplitCoordinates",
    value: function getSplitCoordinates() {
      var coordList = new _CoordinateList.default();
      this.addEndpoints();
      var it = this.iterator();
      var eiPrev = it.next();

      while (it.hasNext()) {
        var ei = it.next();
        this.addEdgeCoordinates(eiPrev, ei, coordList);
        eiPrev = ei;
      }

      return coordList.toCoordinateArray();
    }
  }, {
    key: "addCollapsedNodes",
    value: function addCollapsedNodes() {
      var collapsedVertexIndexes = new _ArrayList.default();
      this.findCollapsesFromInsertedNodes(collapsedVertexIndexes);
      this.findCollapsesFromExistingVertices(collapsedVertexIndexes);

      for (var it = collapsedVertexIndexes.iterator(); it.hasNext();) {
        var vertexIndex = it.next().intValue();
        this.add(this._edge.getCoordinate(vertexIndex), vertexIndex);
      }
    }
  }, {
    key: "print",
    value: function print(out) {
      out.println("Intersections:");

      for (var it = this.iterator(); it.hasNext();) {
        var ei = it.next();
        ei.print(out);
      }
    }
  }, {
    key: "findCollapsesFromExistingVertices",
    value: function findCollapsesFromExistingVertices(collapsedVertexIndexes) {
      for (var i = 0; i < this._edge.size() - 2; i++) {
        var p0 = this._edge.getCoordinate(i);

        var p1 = this._edge.getCoordinate(i + 1);

        var p2 = this._edge.getCoordinate(i + 2);

        if (p0.equals2D(p2)) {
          collapsedVertexIndexes.add(new _Integer.default(i + 1));
        }
      }
    }
  }, {
    key: "addEdgeCoordinates",
    value: function addEdgeCoordinates(ei0, ei1, coordList) {
      var npts = ei1.segmentIndex - ei0.segmentIndex + 2;

      var lastSegStartPt = this._edge.getCoordinate(ei1.segmentIndex);

      var useIntPt1 = ei1.isInterior() || !ei1.coord.equals2D(lastSegStartPt);

      if (!useIntPt1) {
        npts--;
      }

      var ipt = 0;
      coordList.add(new _Coordinate.default(ei0.coord), false);

      for (var i = ei0.segmentIndex + 1; i <= ei1.segmentIndex; i++) {
        coordList.add(this._edge.getCoordinate(i));
      }

      if (useIntPt1) {
        coordList.add(new _Coordinate.default(ei1.coord));
      }
    }
  }, {
    key: "iterator",
    value: function iterator() {
      return this._nodeMap.values().iterator();
    }
  }, {
    key: "addSplitEdges",
    value: function addSplitEdges(edgeList) {
      this.addEndpoints();
      this.addCollapsedNodes();
      var it = this.iterator();
      var eiPrev = it.next();

      while (it.hasNext()) {
        var ei = it.next();
        var newEdge = this.createSplitEdge(eiPrev, ei);
        edgeList.add(newEdge);
        eiPrev = ei;
      }
    }
  }, {
    key: "findCollapseIndex",
    value: function findCollapseIndex(ei0, ei1, collapsedVertexIndex) {
      if (!ei0.coord.equals2D(ei1.coord)) return false;
      var numVerticesBetween = ei1.segmentIndex - ei0.segmentIndex;

      if (!ei1.isInterior()) {
        numVerticesBetween--;
      }

      if (numVerticesBetween === 1) {
        collapsedVertexIndex[0] = ei0.segmentIndex + 1;
        return true;
      }

      return false;
    }
  }, {
    key: "findCollapsesFromInsertedNodes",
    value: function findCollapsesFromInsertedNodes(collapsedVertexIndexes) {
      var collapsedVertexIndex = new Array(1).fill(null);
      var it = this.iterator();
      var eiPrev = it.next();

      while (it.hasNext()) {
        var ei = it.next();
        var isCollapsed = this.findCollapseIndex(eiPrev, ei, collapsedVertexIndex);
        if (isCollapsed) collapsedVertexIndexes.add(new _Integer.default(collapsedVertexIndex[0]));
        eiPrev = ei;
      }
    }
  }, {
    key: "getEdge",
    value: function getEdge() {
      return this._edge;
    }
  }, {
    key: "addEndpoints",
    value: function addEndpoints() {
      var maxSegIndex = this._edge.size() - 1;
      this.add(this._edge.getCoordinate(0), 0);
      this.add(this._edge.getCoordinate(maxSegIndex), maxSegIndex);
    }
  }, {
    key: "createSplitEdge",
    value: function createSplitEdge(ei0, ei1) {
      var npts = ei1.segmentIndex - ei0.segmentIndex + 2;

      var lastSegStartPt = this._edge.getCoordinate(ei1.segmentIndex);

      var useIntPt1 = ei1.isInterior() || !ei1.coord.equals2D(lastSegStartPt);

      if (!useIntPt1) {
        npts--;
      }

      var pts = new Array(npts).fill(null);
      var ipt = 0;
      pts[ipt++] = new _Coordinate.default(ei0.coord);

      for (var i = ei0.segmentIndex + 1; i <= ei1.segmentIndex; i++) {
        pts[ipt++] = this._edge.getCoordinate(i);
      }

      if (useIntPt1) pts[ipt] = new _Coordinate.default(ei1.coord);
      return new _NodedSegmentString.default(pts, this._edge.getData());
    }
  }, {
    key: "add",
    value: function add(intPt, segmentIndex) {
      var eiNew = new _SegmentNode.default(this._edge, intPt, segmentIndex, this._edge.getSegmentOctant(segmentIndex));

      var ei = this._nodeMap.get(eiNew);

      if (ei !== null) {
        _Assert.default.isTrue(ei.coord.equals2D(intPt), "Found equal nodes with different coordinates");

        return ei;
      }

      this._nodeMap.put(eiNew, eiNew);

      return eiNew;
    }
  }, {
    key: "checkSplitEdgesCorrectness",
    value: function checkSplitEdgesCorrectness(splitEdges) {
      var edgePts = this._edge.getCoordinates();

      var split0 = splitEdges.get(0);
      var pt0 = split0.getCoordinate(0);
      if (!pt0.equals2D(edgePts[0])) throw new _RuntimeException.default("bad split edge start point at " + pt0);
      var splitn = splitEdges.get(splitEdges.size() - 1);
      var splitnPts = splitn.getCoordinates();
      var ptn = splitnPts[splitnPts.length - 1];
      if (!ptn.equals2D(edgePts[edgePts.length - 1])) throw new _RuntimeException.default("bad split edge end point at " + ptn);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return SegmentNodeList;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return SegmentNodeList;
}();

exports.default = SegmentNodeList;

SegmentNodeList.constructor_ = function () {
  this._nodeMap = new _TreeMap.default();
  this._edge = null;
  var edge = arguments[0];
  this._edge = edge;
};

var NodeVertexIterator =
/*#__PURE__*/
function () {
  function NodeVertexIterator() {
    _classCallCheck(this, NodeVertexIterator);

    NodeVertexIterator.constructor_.apply(this, arguments);
  }

  _createClass(NodeVertexIterator, [{
    key: "next",
    value: function next() {
      if (this._currNode === null) {
        this._currNode = this._nextNode;
        this._currSegIndex = this._currNode.segmentIndex;
        this.readNextNode();
        return this._currNode;
      }

      if (this._nextNode === null) return null;

      if (this._nextNode.segmentIndex === this._currNode.segmentIndex) {
        this._currNode = this._nextNode;
        this._currSegIndex = this._currNode.segmentIndex;
        this.readNextNode();
        return this._currNode;
      }

      if (this._nextNode.segmentIndex > this._currNode.segmentIndex) {}

      return null;
    }
  }, {
    key: "remove",
    value: function remove() {
      throw new UnsupportedOperationException(this.getClass().getName());
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      if (this._nextNode === null) return false;
      return true;
    }
  }, {
    key: "readNextNode",
    value: function readNextNode() {
      if (this._nodeIt.hasNext()) this._nextNode = this._nodeIt.next();else this._nextNode = null;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return NodeVertexIterator;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_Iterator.default];
    }
  }]);

  return NodeVertexIterator;
}();

NodeVertexIterator.constructor_ = function () {
  this._nodeList = null;
  this._edge = null;
  this._nodeIt = null;
  this._currNode = null;
  this._nextNode = null;
  this._currSegIndex = 0;
  var nodeList = arguments[0];
  this._nodeList = nodeList;
  this._edge = nodeList.getEdge();
  this._nodeIt = nodeList.iterator();
  this.readNextNode();
};